import {ga, initialize as initGa} from 'react-ga'
import {isClient, htmlDecode} from './utils'

let _googleRemarket

const event = values => {
    if (!isClient()) {
      return
    }

    decodeValues(values)

    const obj = {
      hitType: 'event',
      eventCategory: values.category,
      eventAction: values.action,
      eventLabel: values.label
    }

    setBlogCustomDimensions()

    // Set the GA custom dimensions for DRTV Tracking
    ga(() => {
      // Invoke function inside ga readyCallback
      // to guarante ga object is available
      setGACustomDimensions();
    });

    ga('send', obj)
    console.log('GA event', values)
  },

  pageview = page => {
    if (!isClient()) {
      return
    }

    const obj = {
      hitType: 'pageview',
      page
    }

    setBlogCustomDimensions()

    // Set the GA custom dimensions for DRTV Tracking
    ga(() => {
      // Invoke function inside ga readyCallback
      // to guarante ga object is available
      setGACustomDimensions();
    });

    ga('send', obj)
    console.log('GA pageview', page)
  },

  set = (key, value) => {
    if (!isClient()) {
      return
    }

    ga('set', key, value)
    console.log('GA custom dimension', {[key]: value})
  },

  // Set custom dimensions for DRTV Tracking
  setGACustomDimensions = () => {
    if (!isClient()) {
      return
    }
    console.log("Setting GA custom dimensions for DRTV");

    // Get Date/Time that GA event is hit
    const date = new Date();

    const d1 = _getGAClientID();
    const d2 = _getGASessionID(date);
    const d3 = _getCookieValue('user_id');
    const d15 = date.valueOf();

    console.log(`Custom GA Dimensions - ClientID: ${d1}/ SessionID: ${d2}/ UserID: ${d3}/ Timestamp Hit: ${d15}`);

    ga('set', 'dimension1',  d1);
    ga('set', 'dimension2',  d2);
    ga('set', 'dimension3',  d3);
    ga('set', 'dimension15', d15);
  },

  setBlogCustomDimensions = () => {
    if (!isClient()) {
      return
    }
    console.info("Setting blog custom dimensions");
    const cookie = decodeURIComponent(document.cookie)
    const d4 = _getCookieValue('blog_landing') || 'default'
    const d5 = _getCookieValue('blog_lastpage') || 'default'

    console.log("Custom Dimensions: " + d4 + "/" + d5);

    ga('set', 'dimension4', d4);
    ga('set', 'dimension5', d5);
  },

  _getGAClientID = () => {
    const trackers = ga().getAll();

    for (let i = 0; i < trackers.length; i += 1)  {
      if (trackers[i].get('trackingId') === _googleRemarket) {
        // Get the GA clientID for Dimension 1
        console.log('Get the GA clientID for Dimension 1 ', trackers[i].get('clientId'))
        return trackers[i].get('clientId');
      }
    }
    return null;
  },

  _getGASessionID = date => {
    return `${date.getTime()}.${Math.random().toString(36).substring(5)}`;
  },

  _getCookieValue = cookie => {
    let cookieValue = decodeURIComponent(document.cookie).match(new RegExp(`${cookie}=([^;]+)`))

    return cookieValue && cookieValue[1]
  },

  _saveCampaignCookies = () => {
    const gaTrackingParams = [{
      cookieParam: 'kclickid',
      gaParam: 'kclickid'
    }, {
      cookieParam: 'kclickid_date',
      gaParam: 'kclickid_date'
    }, {
      cookieParam: 'gclid',
      gaParam: 'location'
    }, {
      cookieParam: 'utm_campaign',
      gaParam: 'campaignName'
    }, {
      cookieParam: 'utm_medium',
      gaParam: 'campaignMedium'
    }, {
      cookieParam: 'utm_source',
      gaParam: 'campaignSource'
    }, {
      cookieParam: 'utm_referrer',
      gaParam: 'referrer'
    }, {
      cookieParam: 'utm_content',
      gaParam: 'campaignContent'
    }]

    console.log('inside saveCampaignCookies: ')

    gaTrackingParams.forEach((gaTrackingParam) =>  {
      let cookieParamValue = _getCookieValue(gaTrackingParam.cookieParam)

      if (cookieParamValue) {
        cookieParamValue = (gaTrackingParam.cookieParam === 'gclid' && window.location.href + `?glcid=${cookieParamValue}`) || cookieParamValue
        console.log(`${gaTrackingParam.gaParam}: ${cookieParamValue}`)

        ga('set', gaTrackingParam.gaParam, cookieParamValue)
      }
    })
  },

  initialize = (googleRemarket, googleDomain) => {
    if (!isClient()) {
      return
    }

    _googleRemarket = googleRemarket

    initGa(googleRemarket, googleDomain)
    console.log('GA initialize', googleRemarket, googleDomain)

    if (document.referrer.includes('credible.com/partners-widgets')) {
      ga('set', 'allowAdPersonalizationSignals', false)
      ga('set', 'allowAdFeatures', false)
    }

    _saveCampaignCookies()
  },

  decodeValues = values => {
    values.category = htmlDecode(values.category)
    values.action = htmlDecode(values.action)
    values.label = htmlDecode(values.label)

    return values
  }

export {
  event,
  pageview,
  set,
  initialize
}

export default {
  event,
  pageview,
  set,
  initialize
}
